import React from "react";
import PropTypes from "prop-types";

export function RepeatIcon({ fillColor = "#109CDA", strokeColor = "#2BAFE6", ...props }) {
  return (
    <svg
      width="90"
      height="90"
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.5" y="0.5" width="89" height="89" rx="44.5" fill="#F3FAFD" />
      <rect
        x="0.5"
        y="0.5"
        width="89"
        height="89"
        rx="44.5"
        stroke={strokeColor}
        strokeOpacity="2.25"
      />
      <path
        d="M40.1866 42.653V29.1063C40.1866 28.573 40.3466 28.053 40.64 27.613L44.28 22.1996C44.8533 21.333 46.28 20.7196 47.4933 21.173C48.8 21.613 49.6666 23.0796 49.3866 24.3863L48.6933 28.7463C48.64 29.1463 48.7466 29.5063 48.9733 29.7863C49.2 30.0396 49.5333 30.1996 49.8933 30.1996H55.3733C56.4266 30.1996 57.3333 30.6263 57.8666 31.373C58.3733 32.093 58.4666 33.0263 58.1333 33.973L54.8533 43.9596C54.44 45.613 52.64 46.9596 50.8533 46.9596H45.6533C44.76 46.9596 43.5066 46.653 42.9333 46.0796L41.2266 44.7596C40.5733 44.2663 40.1866 43.4796 40.1866 42.653Z"
        fill={fillColor}
      />
      <path
        d="M35.9466 26.5059H34.5733C32.5066 26.5059 31.6666 27.3059 31.6666 29.2792V42.6925C31.6666 44.6659 32.5066 45.4659 34.5733 45.4659H35.9466C38.0133 45.4659 38.8533 44.6659 38.8533 42.6925V29.2792C38.8533 27.3059 38.0133 26.5059 35.9466 26.5059Z"
        fill={fillColor}
      />
      <path
        d="M44.103 61.045H41.893V64.997C42.465 65.4217 43.2147 66.102 44.142 67.038L43.245 67.935C42.6903 67.3543 42.2267 66.895 41.854 66.557C41.6807 67.9523 40.8053 68.65 39.228 68.65C38.3007 68.65 37.5813 68.4377 37.07 68.013C36.5587 67.597 36.303 67.0077 36.303 66.245C36.303 65.5343 36.5543 64.9797 37.057 64.581C37.5683 64.1737 38.292 63.97 39.228 63.97C39.696 63.97 40.151 64.0567 40.593 64.23V61.045H36.693V59.875H40.593V57.795H41.893V59.875H44.103V61.045ZM35.094 58.133C34.678 59.7363 34.47 61.4653 34.47 63.32C34.47 65.1747 34.678 66.9037 35.094 68.507L33.82 68.663C33.3867 67.0163 33.17 65.2353 33.17 63.32C33.17 61.4047 33.3867 59.6237 33.82 57.977L35.094 58.133ZM40.593 65.595C40.1077 65.309 39.631 65.166 39.163 65.166C38.123 65.166 37.603 65.5257 37.603 66.245C37.603 67.0683 38.123 67.48 39.163 67.48C39.6657 67.48 40.0297 67.363 40.255 67.129C40.4803 66.895 40.593 66.5137 40.593 65.985V65.595ZM53.853 59.264L55.101 58.874C55.6817 60.0007 56.1237 61.2833 56.427 62.722C56.739 64.152 56.895 65.6297 56.895 67.155H55.53C55.53 65.7423 55.3827 64.347 55.088 62.969C54.7933 61.591 54.3817 60.356 53.853 59.264ZM48.38 59.108C47.99 60.4773 47.795 61.9247 47.795 63.45C47.795 64.49 47.9727 65.3697 48.328 66.089C48.6833 66.7997 49.0387 67.155 49.394 67.155C49.6367 67.155 49.953 66.8907 50.343 66.362C50.733 65.8333 51.1187 65.0793 51.5 64.1L52.735 64.581C52.3017 65.8117 51.76 66.778 51.11 67.48C50.4687 68.1733 49.862 68.52 49.29 68.52C48.5793 68.52 47.925 68.026 47.327 67.038C46.729 66.05 46.43 64.854 46.43 63.45C46.43 61.8293 46.638 60.33 47.054 58.952L48.38 59.108Z"
        fill={fillColor}
      />
    </svg>
  );
}

RepeatIcon.propTypes = {
  fillColor: PropTypes.string,
  strokeColor: PropTypes.string,
};
